
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import * as healthDataApi from 'services/api/healthdata-api';

export const fetchAIHealthSummary = createAsyncThunk(
    'aiHealthSummary/fetch',
    async (profileId, { getState, rejectWithValue }) => {
        try {
            const state = getState();
            const res = await healthDataApi.fetchAIHealthSummaryApi({
                state,
                profileId
            });
            return res;
        } catch (err) {
            return rejectWithValue(err);
        }
    }
);

const aiHealthSummarySlice = createSlice({
    name: 'aiHealthSummary',
    initialState: {
        data: null,
        loading: false,
        error: false
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchAIHealthSummary.pending, (state) => {
                state.loading = true;
                state.error = false;
            })
            .addCase(fetchAIHealthSummary.fulfilled, (state, action) => {
                state.loading = false;
                state.data = action.payload;
            })
            .addCase(fetchAIHealthSummary.rejected, (state) => {
                state.loading = false;
                state.error = true;
            });
    }
});

export default aiHealthSummarySlice.reducer;
